export const load = () => ({
	title: 'Upgrade windows to boost NOI: IndowPRO for Commercial',
	h1: 'Upgrade Your Windows, Boost Your Bottom Line',
	description:
		'IndowPRO is the non-disruptive window upgrade that cuts energy costs (U-0.136) and noise (STC 51) to increase tenant satisfaction and net operating income.',
	showTitle: true,
});
